/**
 * 禁用PhotoSwipe点击放大功能，保留放大镜效果
 */
(function() {
  // 等待DOM加载完成
  function init() {
    const galleries = document.querySelectorAll('.m-media-gallery[data-enable-image-zoom="true"]');

    galleries.forEach(gallery => {
      // 移除PhotoSwipe相关的点击事件
      const mediaItems = gallery.querySelectorAll('.m-product-media--item.media-type-image');

      mediaItems.forEach(item => {
        // 移除可能存在的onclick属性
        item.removeAttribute('onclick');

        // 阻止PhotoSwipe的点击事件
        item.addEventListener('click', (e) => {
          e.preventDefault();
          e.stopPropagation();
          return false;
        }, true); // 使用捕获阶段，优先级更高

        // 确保图片也不触发点击
        const img = item.querySelector('img');
        if (img) {
          img.addEventListener('click', (e) => {
            e.preventDefault();
            e.stopPropagation();
            return false;
          }, true);
        }
      });
    });
  }

  // DOM加载完成后初始化
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // 监听DOM变化，处理动态加载的内容
  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      if (mutation.addedNodes.length > 0) {
        init();
      }
    });
  });

  // 开始观察
  const mainProduct = document.querySelector('.m-main-product--wrapper');
  if (mainProduct) {
    observer.observe(mainProduct, {
      childList: true,
      subtree: true
    });
  }
})();
